<template>
	<div class="container__crudtable__mobile__card">
		<div class="container__crudtable__mobile__card__header">
			<Checkbox v-model="dataObject.isCheckedToDelete" />
			<div
				class="container__crudtable__mobile__card__header__info"
				@click="isOpen = !isOpen"
			>
				<label>
					{{ titleCard }}
					<i :class="['fas fa-angle-down', { isOpen: isOpen }]" />
				</label>
				<label>{{ dataObject[tableConfiguration.subtitleCardPropertie] }}</label>
			</div>
			<div class="container__crudtable__mobile__card__header__button">
				<Button
					color="trv-primary"
					label=""
					icon="fas fa-pencil-alt"
					semantic-class="mini"
					bubble-button
					width-auto
					@click="showEditModelForm(dataObject)"
				/>
			</div>
		</div>
		<div
			v-show="isOpen"
			class="container__crudtable__mobile__card__body"
		>
			<div
				class="container__crudtable__mobile__card__body__info"
				@click="isOpen = !isOpen"
			>
				<div
					v-for="(value, propertieName, key) in dataObject"
					:key="key"
				>
					<div v-if="isPropertieMappedAndActive(propertieName)">
						<label class="container__crudtable__mobile__card__body__propertie">{{
							`${getPropertieName(propertieName)}: `
						}}</label>
						<Tag
							v-if="isToRenderATag(propertieName)"
							:class-name="tableConfiguration.tags[propertieName][value]"
							:label="value"
						/>
						<label v-else>{{ value }}</label>
					</div>
				</div>
			</div>
			<div class="container__crudtable__mobile__card__body__info__button">
				<Button
					color="trv-primary"
					label=""
					icon="fas fa-pencil-alt"
					semantic-class="mini"
					bubble-button
					width-auto
					@click="showEditModelForm(dataObject)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '../../Button/Button'
import Checkbox from '../../Checkbox/Checkbox'
import Tag from '../../Tag/Tag'

export default {
	components: { Button, Checkbox, Tag },
	props: {
		headers: {
			type: Array,
			required: true,
		},
		/**
		 * Objeto que terá suas informações mostradas para o usuário
		 */
		dataObject: Object,
		/**
		 * Funcao para exibir a tela para edicao de objeto
		 */
		showEditModelForm: Function,
		/**
		 * Configuracao da tabela
		 */
		tableConfiguration: Object,
	},
	data() {
		return {
			/**
			 * Verifica se o card está aberto ou fechado para exibir as informacoes do objeto
			 */
			isOpen: false,
		}
	},
	computed: {
		/**
		 * Retorna apenas as colunas que estão ativas
		 */
		activeHeaders() {
			return this.headers.filter((f) => f.isActive)
		},
		titleCard() {
			if (this.tableConfiguration.prefix) {
				return `${this.tableConfiguration.prefix}-${
					this.dataObject[this.tableConfiguration.titleCardPropertie]
				}`
			} else {
				return this.dataObject[this.tableConfiguration.titleCardPropertie]
			}
		},
	},
	methods: {
		/**
		 * Verifica se a propriedade atual foi mapeada para ser exibida
		 */
		isPropertieMappedAndActive(propertie) {
			const titlePropertie = this.tableConfiguration.titleCardPropertie
			const subtitlePropertie = this.tableConfiguration.subtitleCardPropertie
			return this.activeHeaders.some(
				(s) => s.key === propertie && s.key !== titlePropertie && s.key !== subtitlePropertie,
			)
		},
		/**
		 * Verifica se e para ser renderizado uma tag
		 */
		isToRenderATag(propertie) {
			if (this.tableConfiguration?.tags) {
				return this.tableConfiguration.tags[propertie] ? true : false
			}
			return false
		},
		/**
		 * Recupera o nome da propriedade
		 */
		getPropertieName(propertieName) {
			let headerName = this.headers.find((f) => f.key === propertieName)
			return headerName.value
		},
	},
}
</script>

<style scoped>
i {
	cursor: pointer;
	transition: transform 0.2s ease-in-out;
}

i.isOpen {
	transform: rotate(180deg);
	color: rgb(var(--color-default));
}

.container__crudtable__mobile__card {
	margin: 1rem 0;
	border: solid 1px rgba(var(--color-primary), 0.3);
	border-radius: 3px;
	padding: 1rem;
}

.container__crudtable__mobile__card__header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	user-select: none;
}

.container__crudtable__mobile__card__header__info {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-left: 1rem;
}

.container__crudtable__mobile__card__header__info label:nth-child(1) {
	font-size: 1.2rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}

.container__crudtable__mobile__card__header__info label:nth-child(2) {
	font-size: 0.8rem;
	color: gray;
}

.container__crudtable__mobile__card__header__button {
	display: none;
}

.container__crudtable__mobile__card__body {
	font-size: 0.75rem;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.container__crudtable__mobile__card__body__info {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.container__crudtable__mobile__card__body__propertie {
	font-weight: 700;
}

@media screen and (min-width: 576px) {
	.container__crudtable__mobile__card__header__button {
		display: block;
	}

	.container__crudtable__mobile__card__body__info__button {
		display: none;
	}
}
</style>
